import { RecordCategory } from '../../../../../../entities/recordings';

export const recordsTabs = [
  { id: RecordCategory.MY, name: 'My recordings' },
  { id: RecordCategory.SHARED, name: 'Shared with me' },
];
